import { createSlice } from '@reduxjs/toolkit';
import { pageModel } from '../../utils/model';

const initialState = {
    page: pageModel
}

const locationSlice = createSlice({
    name: 'location',
    initialState,
    reducers: {
        setLocationPageAction: (state, action) => {
            state.page = action.payload
        },
        getLocationPageAction: (state, action) => {
            const content = state.page.content.concat(action.payload.content)
            state.page = { ...action.payload, content }
        },
        addLocationAction: (state, action) => {
            state.page.content.unshift(action.payload)
        },
        updateLocationAction: (state, action) => {
            const content = state.page.content.map((x) => {
                if (x.id === action.payload.id) return action.payload
                else return x
            })
            state.page.content = content
        },
        deleteLocationAction: (state, action) => {
            const content = state.page.content.filter(p => p.id !== action.payload)
            state.page.content = content
        },
    },
});

export const { setLocationPageAction, getLocationPageAction, addLocationAction, updateLocationAction, deleteLocationAction } = locationSlice.actions;
export default locationSlice;